



















import Vue from "vue";

export default Vue.extend({
  props: {
    color: {
      type: String,
      default: "white"
    },
    textColor: {
      type: String,
      default: "inherit"
    },
    img: {
      type: String,
      required: false
    },
    to: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    btnStyle() {
      return {
        backgroundColor: this.color,
        color: this.textColor
      };
    }
  }
});
